<template>
    <div>
        <b-dropdown
            dropleft
            right
            size="xs"
        >

            <template slot="button-content">
                <i class="fa fa-caret-down" />
            </template>

            <b-dropdown-header>Cost Actions</b-dropdown-header>

            <b-dropdown-item @click="editCost" v-if="!cost.is_approved">
                <i class="fa fa-fw fa-pencil" />
                <span class="ml-2">Edit</span>
            </b-dropdown-item>

            <b-dropdown-item @click="addResources" v-if="!cost.is_approved">
                <i class="fa fa-fw fa-cube" />
                <span class="ml-2">Add Resources</span>
            </b-dropdown-item>

            <b-dropdown-item @click="addToGroup" v-if="!cost.is_approved">
                <i class="fa fa-fw fa-arrow-right" />
                <span class="ml-2">Add to Group</span>
            </b-dropdown-item>

            <b-dropdown-item
                v-if="hasGroup"
                @click="removeFromGroup"
            >
                <i class="fa fa-fw fa-arrow-right" />
                <span class="ml-2">Remove from Group</span>
            </b-dropdown-item>

            <b-dropdown-item
                v-if="canBeAddedToTab && !cost.is_approved"
                @click="addToTab"
            >
                <i class="fa fa-fw fa-arrow-right" />
                <span class="ml-2">Add to Tab</span>
            </b-dropdown-item>

            <b-dropdown-item
                v-if="hasTab"
                @click="removeFromTab"
            >
                <i class="fa fa-fw fa-arrow-right" />
                <span class="ml-2">Remove from Tab</span>
            </b-dropdown-item>

            <b-dropdown-item @click="duplicateCost" >
                <i class="fa fa-fw fa-copy" />
                <span class="ml-2">Duplicate</span>
            </b-dropdown-item>

            <b-dropdown-item @click="unApproveCosts" v-if="canApproveCosts && hasApprovedCost">
                <i class="fa fa-fw fa-check" />
                <span class="ml-2">Unapprove cost</span>
            </b-dropdown-item>

            <b-dropdown-item @click="approveCosts" v-else-if="canApproveCosts">
                <i class="fa fa-fw fa-check" />
                <span class="ml-2">Approve cost</span>
            </b-dropdown-item>

            <b-dropdown-item
                v-if="cost.reconciled"
                @click="unReconcileCost"
            >
                <i class="fa fa-fw fa-check" />
                <span class="ml-2">Unreconcile</span>
            </b-dropdown-item>

            <b-dropdown-item
                v-else
                @click="reconcileCost"
            >
                <i class="fa fa-fw fa-check" />
                <span class="ml-2">Reconcile</span>
            </b-dropdown-item>

            <b-dropdown-item @click="deleteCost">
                <i class="fa fa-fw fa-trash" />
                <span class="ml-2">Delete</span>
            </b-dropdown-item>

        </b-dropdown>
    </div>
</template>

<script>
export default {

    props: {
        cost: {
            type: Object,
            required: true,
        },
    },

    computed: {
        canBeAddedToTab() {
            return !this.hasGroup && this.$store.getters['costable/areTabsEnabled'];
        },
        hasGroup() {
            return this.cost.group_id;
        },
        hasTab() {
            return this.cost.tab_id;
        },
        hasApprovedCost() {
            return this.cost.is_approved;
        },
        canApproveCosts() {
            return this.$store.getters['costable/canApproveCosts'];
        },
    },

    methods: {
        editCost() {
            this.$eventBus.$emit(this.$events.openEditCostModal, {
                cost: this.cost,
            });
        },
        addResources() {
            this.$eventBus.$emit(this.$events.openCostResourcePickerModal, {
                costId: this.cost.id,
            });
        },
        deleteCost() {
            this.$eventBus.$emit(this.$events.openConfirmationModal, {
                title: 'Delete Cost',
                body: 'Are you sure you want to delete this cost?',
                submitButtonVariant: 'danger',
                onSubmit: () => {
                    this.$store.dispatch('costable/deleteCosts', [this.cost.id]);
                },
            });
        },
        duplicateCost() {
            this.$eventBus.$emit(this.$events.openConfirmationModal, {
                title: 'Duplicate Cost',
                body: 'Are you sure you want to duplicate this cost?',
                submitButtonVariant: 'success',
                onSubmit: () => {
                    this.$store.dispatch('costable/duplicateCost', [this.cost.id]);
                },
            });
        },
        approveCosts() {
            this.$eventBus.$emit(this.$events.openConfirmationModal, {
                title: `Approve cost`,
                body: 'Are you sure you want to approve this cost?',
                submitButtonVariant: 'success',
                onSubmit: () => {
                    this.$store.dispatch('costable/approveCosts', [this.cost.id]);
                },
            });
        },
        unApproveCosts() {
            this.$eventBus.$emit(this.$events.openConfirmationModal, {
                title: 'UnApprove cost',
                body: 'Are you sure you want to Unapprove this cost?',
                submitButtonVariant: 'success',
                onSubmit: () => {
                    this.$store.dispatch('costable/unapproveCosts', [this.cost.id]);
                },
            });
        },
        reconcileCost() {
            this.$eventBus.$emit(this.$events.openConfirmationModal, {
                title: 'Reconcile Cost',
                body: 'Are you sure you want to reconcile this cost?',
                submitButtonVariant: 'success',
                onSubmit: () => {
                    this.$store.dispatch('costable/reconcileCosts', [this.cost.id]);
                },
            });
        },
        unReconcileCost() {
            this.$eventBus.$emit(this.$events.openConfirmationModal, {
                title: 'Unreconcile Cost',
                body: 'Are you sure you want to unreconcile this cost?',
                submitButtonVariant: 'success',
                onSubmit: () => {
                    this.$store.dispatch('costable/unreconcileCosts', [this.cost.id]);
                },
            });
        },
        addToTab() {
            this.$eventBus.$emit(this.$events.openAddToTabModal, {
                title: 'Add Cost to Tab',
                costIds: [this.cost.id],
            });
        },
        addToGroup() {
            this.$eventBus.$emit(this.$events.openAddToGroupModal, {
                title: 'Add Cost to Group',
                costIds: [this.cost.id],
            });
        },
        removeFromGroup() {
            this.$eventBus.$emit(this.$events.openConfirmationModal, {
                title: 'Remove Cost from group',
                body: 'Are you sure you want to remove this cost from this group?',
                onSubmit: () => {
                    this.$store.dispatch('costable/removeCostFromGroup', [this.cost.id]);
                },
            });
        },
        removeFromTab() {
            this.$eventBus.$emit(this.$events.openConfirmationModal, {
                title: 'Remove Cost from tab',
                body: 'Are you sure you want to remove this cost from this tab?',
                onSubmit: () => {
                    this.$store.dispatch('costable/removeCostFromTab', [this.cost.id]);
                },
            });
        },
    },

};
</script>
